import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/home-page';
import { VacancyPage } from './pages/vacancies';
import { Header } from './components/header'; // Import your Header
import Footer from './components/footer';
import { ContactPage } from './pages/contact';
import AboutUs from './pages/about-us';
import Services from './pages/services';

function App() {
  return (
    <Router>
      <Header /> 
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path='/services' element={<Services />} />
        <Route path="/vacancy" element={<VacancyPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
